import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  allLookupSelector,
  getAllLookups,
  lookupTypesSelector,
} from "../../../redux/lookupSlice";
import { api } from "../../../services/api-service";
import LookUpsEmpty from "./LookUpsEmpty";
import LookupsFilter from "./LookupsFilter";
import LookUpsList from "./LookUpsList";
import LookUpsValueAdded from "./LookUpsValueAdded";
import SearchLookups from "./SearchLookups";

const LookUpsMain = () => {
  const allLookups = useSelector(allLookupSelector);
  const lookupTypes = useSelector(lookupTypesSelector);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedLookup, setSelectedLookup] = useState({});
  const [lastSelectedLookup, setLastSelectedLookup] = useState();

  useEffect(() => {
    dispatch(getAllLookups());
  }, []);

  useEffect(() => {
    if (lastSelectedLookup) {
      onSelectLookup(lastSelectedLookup);
    } else if (lookupTypes.length > 0) {
      onSelectLookup(lookupTypes[0]);
    }
  }, [lookupTypes]);

  const result = useMemo(() => {
    if (!search) return lookupTypes;
    return lookupTypes.filter((look) =>
      look.value.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, lookupTypes]);

  const onSelectLookup = (e) => {
    setSelectedLookup(e);
    setLastSelectedLookup(e);
    setSelectedTypes(allLookups.filter((look) => look.type === e.id));
  };

  return (
    <>
      <div className="main-dashboard">
        <div className="mainWrapper">
          <Row className="g-0">
            <Col lg="4">
              <div className="sidebarTemplate">
                <div className="template-header">
                  <h3>Lookups </h3>
                  <LookupsFilter text={search} onChange={(e) => setSearch(e)} />
                </div>
                <div className="template-body">
                  <LookUpsList
                    lookups={result}
                    selected={selectedLookup}
                    setSelected={(e) => onSelectLookup(e)}
                  />
                </div>
              </div>
            </Col>
            <Col lg="8">
              <div className="templateCard">
                <div className="lookups-title w-100">
                  <div className="media-body">
                    <h3>Add Value</h3>
                    <p>You can add values to the selected lookup below</p>
                  </div>
                </div>
                <div className="templateBody">
                  <Row>
                    <Col lg="7">
                      <SearchLookups
                        selected={selectedLookup}
                        onAdded={(e) => setSelectedTypes([...selectedTypes, e])}
                      />
                      <LookUpsValueAdded types={selectedTypes} />
                    </Col>
                  </Row>
                  {/*EMPTY STATE*/}
                  {selectedTypes.length === 0 && <LookUpsEmpty />}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default LookUpsMain;
